export const professions = [
  'Accountant',
  'Actor',
  'Actress',
  'Air Traffic Controller',
  'Architect',
  'Artist',
  'Attorney',
  'Banker',
  'Barber',
  'Bartender',
  'Bookkeeper',
  'Builder',
  'Businessperson',
  'Butcher',
  'Carpenter',
  'Cashier',
  'Chef',
  'Coach',
  'Cruise Ship Attendant',
  'Dental Hygienist',
  'Dentist',
  'Designer',
  'Developer',
  'Dietician',
  'Doctor',
  'Economist',
  'Editor',
  'Electrician',
  'Engineer',
  'Farmer',
  'Filmmaker',
  'Fisherman',
  'Flight Attendant',
  'Jeweler',
  'Judge',
  'Lawyer',
  'Mechanic',
  'Medical Technologist',
  'Musician',
  'Nurse',
  'Nutritionist',
  'Optician',
  'Painter',
  'Pharmacist',
  'Photographer',
  'Physician',
  'Physician\'s Assistant',
  'Pilot',
  'Plumber',
  'Police officer',
  'Politician',
  'Professor',
  'Programmer',
  'Psychologist',
  'Receptionist',
  'Respiratory Therapist',
  'Salesperson',
  'Secretary',
  'Singer',
  'Surgeon',
  'Teacher',
  'Therapist',
  'Translator',
  'Undertaker',
  'Veterinarian',
  'Videographer',
  'Waiter',
  'Waitress',
  'Writer'
];
